import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { FundType } from '../../../../../../models/transactions/fund-type';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-vb-withdrawal-percent-field',
  templateUrl: './vb-withdrawal-percent-field.component.html',
  styleUrls: ['./vb-withdrawal-percent-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VbWithdrawalPercentFieldComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbWithdrawalPercentFieldComponent {
  @Input() fundType!: FundType;
  @Input() balance!: number;

  public percentage!: number | null;
  public disabled = false;

  public onChange = (value: any) => {};
  public onTouched = () => {};

  public handleValueChange(value: number | null) {
    this.percentage = value;
    this.onChange(this.percentage);
    this.onTouched();
  }

  public writeValue(value: any): void {
    if (value !== undefined) {
      this.percentage = value;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
